var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemixDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.903 168.726C189.264 186.214 189.264 194.412 189.264 203.36H148.802C148.802 201.411 148.837 199.628 148.872 197.82C148.982 192.199 149.096 186.338 148.185 174.502C146.982 157.173 139.52 153.323 125.799 153.323H113.643H62.1602V121.795H127.725C145.056 121.795 153.722 116.523 153.722 102.564C153.722 90.2893 145.056 82.8512 127.725 82.8512H62.1602V52H134.946C174.182 52 193.68 70.5318 193.68 100.134C193.68 122.276 179.96 136.716 161.424 139.123C177.071 142.252 186.218 151.157 187.903 168.726V168.726Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.903 168.726C189.264 186.214 189.264 194.412 189.264 203.36H148.802C148.802 201.411 148.837 199.628 148.872 197.82C148.982 192.199 149.096 186.338 148.185 174.502C146.982 157.173 139.52 153.323 125.799 153.323H113.643H62.1602V121.795H127.725C145.056 121.795 153.722 116.523 153.722 102.564C153.722 90.2893 145.056 82.8512 127.725 82.8512H62.1602V52H134.946C174.182 52 193.68 70.5318 193.68 100.134C193.68 122.276 179.96 136.716 161.424 139.123C177.071 142.252 186.218 151.157 187.903 168.726V168.726Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1602 203.36V179.857H104.943C112.089 179.857 113.641 185.157 113.641 188.318V203.36H62.1602Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 203.36V203.52H62.16H113.641H113.801V203.36V188.318C113.801 186.716 113.409 184.563 112.1 182.806C110.786 181.041 108.561 179.697 104.943 179.697H62.16H62V179.857V203.36Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.32
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemixDark);
export default __webpack_public_path__ + "static/media/Remix-Dark.9e61b0f8bbf9e36a6762c4d0b3fd90a5.svg";
export { ForwardRef as ReactComponent };